<template>
    <div class="main">
    <div class="home">
        <breadcrumb></breadcrumb>
        <div class="innerSelect">
        <el-row class="rowButton">
            <el-col :span="6">
            <span class="applicationText1" :span="6">申请状态查询</span>
            </el-col>
            <el-col :span="18" style="text-align: right;">
                <!--<el-button class="serch-button" type="primary">下载历史申请表</el-button>-->
                <!--<el-button class="serch-button" type="primary">下载查询结果</el-button>-->
            </el-col>
        </el-row>
        <el-form>
            <div class="tablestyle">
                <el-table :data="tableData" border style="width: 99.9%" >
                    <el-table-column type="selection" label="全选"/>
                    <el-table-column label="序号" width="70px">
                        <template slot-scope="scope">{{scope.$index+1}}</template>
                    </el-table-column>
                    <el-table-column prop="id" label="申请索引号" :show-overflow-tooltip="true"/>
                    <el-table-column prop="title" :show-overflow-tooltip="true" label="标题"/>
                    <el-table-column prop="status" label="申请状态"/>
                    <el-table-column prop="replyType" label="答复类型"/>
                    <el-table-column prop="replyContent" :show-overflow-tooltip="true" label="答复内容"/>
                    <el-table-column label="申请提交日期">
                        <template slot-scope="scope">
                            <span>{{scope.row.createTime==null ? "" : scope.row.createTime.substring(0,10)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180px"  align="center">
                        <template slot-scope="scope" >
                            <el-button class="look" size="mini" type="primary"  @click="route_goFun10(scope.row)">查看</el-button>
                            <el-button class="look" size="mini" type="primary" :disabled="scope.row.status != '补正告知中'" @click="route_goFun11(scope.row)" >补正</el-button>
                            <el-button class="look" size="mini" type="primary" :disabled="scope.row.status == '已撤回'||scope.row.status == '已办结'"  @click="cancel(scope.row)" style="background-color: #F40000;border-color: #F40000">撤回</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="margin-top: 20px">
                    <div class="pagination">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="pagination.pageNum"
                                :page-sizes="[5, 10, 15, 20]"
                                :page-size="pagination.pageSize"
                                background
                                layout="total, sizes,prev, pager, next,jumper"
                                :total="pagination.count"
                                prev-text="上一页"
                                next-text="下一页">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </el-form>
        </div>
    </div>
    </div>
</template>

<script>
    import breadcrumb from "@/components/breadcrumb"
    import router from '@/router'
    export default {
        beforeRouteEnter(to, from, next) {
            next()
            if(sessionStorage.getItem('selectresult')!='2'){
                router.push({path:'/select-result'})
            }
        },

        data() {
            return {
                disabled:false,
                 form1: {
                    tel: '',
                    certificateNo: '',
                    pageSize: 5,
                     pageNum:''
                },
                pagination: {
                    count: 0,   //总页数
                    pageSize: 5,  //每页限制
                    pages: 0,
                    pageNum: 1,  //当前页
                    list: []
                },
                form: {
                    code: '',
                    id: '',
                    applicantType: '',
                    name: '',
                    tel: '',
                    certificateType: '',
                    certificateNo: '',
                    email: '',
                    postalcode: '',
                    address: '',
                    legal: '',
                    organizationType: '',
                    licenseInfo: '',
                    contactName: '',
                    title: '',
                    plicationPurpose: '',
                    content: '',
                    accessWay: '',
                    licenceFront: '',
                    licenceBack: '',
                    attachment: '',
                    createTime: '',
                    updateTime: '',
                    creatorId: '',
                    updateUserId: '',
                    delFlag: '',
                    status: ''
                },
                tableData: [],
                isActive: 0
            }
        },
        mounted() {
            this.getParams()
            this.PageSelect()
        },
        methods: {
            getParams() {
                const router1 = this.$route.query.tel
                this.form1.tel = router1
                const router2 = this.$route.query.certificateNo
                this.form1.certificateNo = router2
                const router3 = this.$route.query.pageSize
                this.form1.pageSize = router3
            },
            // 分页查询
            PageSelect() {
                this.form1.pageSize = this.pagination.pageSize;
                this.form1.pageNum = this.pagination.pageNum;
                this.$axios({
                    url: '/application/queryAppReply',
                    method: 'post',
                    data: this.$axios.encrypt(this.form1)
                }).then(({data}) => {
                    const that = this
                    // that.tableData = data.result
                    that.pagination = data;
                    that.tableData = data.result
                })
            },
            // 撤回
            cancel(row) {
                this.$axios({
                    url: '/application/withdrawApp',
                    method: 'get',
                    params: {
                        id: row.id
                    }
                }).then(({data}) => {
                    if (data.code == 200) {
                        this.$message({
                            showClose: true,
                            message: '撤回成功!',
                            type: 'success'
                        });
                        // this.reload();
                        this.PageSelect()
                    } else {
                        alert(data.msg)
                    }
                })
            },
            //补正
            route_goFun11(row) {
                this.$router.push({
                    path: '/apply-table-view',
                    query: {
                        name: '查看申请表格',
                        id:11,
                        id3: row.replyId,
                        id4: row.id
                    }
                })
            },
            // 查看详情
            route_goFun10(row) {
                this.$router.push({
                    path: '/select-result-view',
                    query: {
                        name: '查看申请详情',
                        id: 10,
                        id2: row.id,
                        id3: row.replyId,
                    }
                })
            },
            //每页下拉显示数据
            handleSizeChange: function (size) {
                this.pagination.pageSize = size;
                this.PageSelect();
            },
            //点击第几页
            handleCurrentChange: function (pageNum) {
                this.pagination.pageNum = pageNum;
                this.PageSelect();
            },
        },

        components: {
            breadcrumb
        },
    }

</script>
<style>

</style>
